module.exports = __webpack_public_path__ + "assets/img/151209310918031600.da4f7186.jpg";